import script from "./UserMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserMessages.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__